export default "__VITE_ASSET__ojB4JGsO__"